import { __DEV__ } from '../constants'

export function log(...args: any[]): void {
  if (__DEV__) console.log(...args)
}
